import {Box, Stack} from '@chakra-ui/react';
import * as React from 'react';
import ImageView from './ImageView';

const GridView = ({data}) => {
    const fitToHero = 60; //  + 33 + 72;

    return (
        <Box pt={'33px'} pb={['52px', '52px', '72px']}>
            <Stack
                height={{lg: `calc(800px - ${fitToHero}px)`}}
                justifyContent={'end'}
                minHeight={{base: 'auto'}}
                direction={{base: 'row'}}
                spacing={'20px'}
                ml={'auto'}
            >
                <Stack direction={'column'} spacing={'20px'} maxW={{md: '482px'}}>
                    <ImageView
                        draggable={'false'}
                        objectPosition="center"
                        src={data?.acf?.image_1}
                        alt="Lovely Image"
                        height={'100%'}
                    />
                    <ImageView
                        draggable={'false'}
                        objectPosition="center"
                        src={data?.acf?.image_2}
                        alt="Lovely Image"
                        height={'100%'}
                    />
                    <ImageView
                        draggable={'false'}
                        objectPosition="center"
                        src={data?.acf?.image_3}
                        alt="Lovely Image"
                        height={'100%'}
                    />
                </Stack>
                <Stack spacing={'20px'} maxW={{md: '315px'}} minW={{lg: '255px'}}>
                    <ImageView
                        draggable={'false'}
                        objectPosition="center"
                        src={data?.acf?.image_4}
                        alt="Lovely Image"
                        height={'100%'}
                    />
                    <ImageView
                        draggable={'false'}
                        objectPosition="center"
                        src={data?.acf?.image_5}
                        alt="Lovely Image"
                        height={'100%'}
                    />
                </Stack>
            </Stack>
        </Box>
    );
};
export default GridView;
